import type { AreaFrameUpdateData } from "@situate/contracts";

export interface LiveTrackHistorySample {
  id: string;
  trackId: string;
  areaId: string;
  objectId: string;
  worldX: number;
  worldY: number;
  tick: number;
  expiresAtTick: number;
}

export function advanceLiveTrackHistory(
  previous: LiveTrackHistorySample[],
  tick: number,
  frame: AreaFrameUpdateData,
  ttlTicks: number
): LiveTrackHistorySample[] {
  const activeTrackIds = new Set(
    frame.objects.map(
      (object) =>
        `${encodeURIComponent(frame.area_id)}:${encodeURIComponent(object.track_id ?? object.object_id)}`
    )
  );
  const next = previous.filter(
    (sample) =>
      sample.expiresAtTick > tick &&
      (sample.areaId !== frame.area_id || activeTrackIds.has(sample.trackId))
  );

  for (const object of frame.objects) {
    const trackId = `${encodeURIComponent(frame.area_id)}:${encodeURIComponent(object.track_id ?? object.object_id)}`;
    next.push({
      id: `${trackId}:${tick}`,
      trackId,
      areaId: frame.area_id,
      objectId: object.object_id,
      worldX: object.position.x,
      worldY: object.position.y,
      tick,
      expiresAtTick: tick + ttlTicks,
    });
  }

  return next;
}
